/** Подкрепление после реванша (MADR 0019): выбор «1 из 3» по очереди, варианты — от сервера (`player.revivePicks`). */
import type { WindowProps } from "../kit";
import { BoostChoiceView } from "../boost-choice/view";
import { appStore, registerWindow, useStore, useT } from "../../../app";
import { actions } from "../actions";
import { useEffect, useState } from "preact/hooks";

export function ReviveBoost({ close }: WindowProps<"reviveBoost">) {
  const t = useT();
  const picks = useStore(appStore, (s) => s.player?.revivePicks ?? null);
  const [busy, setBusy] = useState(false);
  // всё выбрано (или волна уже сыграна) — окно закрывается, бой идёт
  useEffect(() => {
    if (!picks) close();
  }, [picks === null]);
  if (!picks) return null;
  return (
    <BoostChoiceView
      kind="reviveBoost"
      wave={null}
      heading={t("win.reviveBoost.title", { n: picks.of - picks.left + 1, max: picks.of })}
      options={picks.options}
      hint={null}
      busy={busy}
      onChoose={(index) => {
        if (busy) return;
        setBusy(true);
        const boostId = picks.options[index]!.boostId;
        void Promise.resolve(actions().reviveBoost({ index, boostId })).finally(() => setBusy(false));
      }}
    />
  );
}

export function register(): void {
  registerWindow("reviveBoost", ReviveBoost);
}
